module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry-desktop@2x-7b722ae995cb3c1d1f8696b2c423db11.webp";